import React from "react";

export const SlotMentionContext = React.createContext<any>({});